import { ChevronDownIcon } from '@heroicons/react/24/outline';
import React from 'react';
import stlIcon from '../../assets/icons/stl.svg';
import xMark from '../../assets/icons/x-mark.svg';
import { FileType } from '../../providers/patient/PatientSubmissionContext';

export const STL_TYPES = [
    { value: 'upper', label: 'Upper jaw' },
    { value: 'lower', label: 'Lower jaw' },
    { value: 'occlusion', label: 'Occlusion' }
];

const STLTypeDropdown: React.FC<{
    stl: FileType;
    onTypeChange: (stlId: string, type: string) => void;
    showTypeRequired?: boolean;
}> = ({ stl, onTypeChange, showTypeRequired }) => (
    <div className="relative">
        <select
            value={stl.type}
            onChange={(e) => onTypeChange(stl.id, e.target.value)}
            className={`w-full h-10 px-4 py-2.5 bg-white border rounded-lg text-sm text-gray-800 appearance-none pr-10 focus:outline-none focus:ring-2 ${
                showTypeRequired
                    ? 'border-red-500 focus:ring-red-200 focus:border-red-500'
                    : 'border-gray-200 focus:ring-blue-500 focus:border-blue-500'
            }`}
        >
            <option value="" disabled>
                Select type
            </option>
            {STL_TYPES.map((type) => (
                <option key={type.value} value={type.value}>
                    {type.label}
                </option>
            ))}
        </select>
        <div className="absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
            <ChevronDownIcon className="w-4 h-4 text-gray-600" />
        </div>
    </div>
);

const RemoveButton: React.FC<{ onClick: () => void }> = ({ onClick }) => (
    <button
        onClick={onClick}
        className="w-4 h-4 bg-white rounded-full flex items-center justify-center text-white transition-opacity opacity-0 group-hover:opacity-100"
    >
        <img src={xMark} alt="Remove" className="w-3 h-3" />
    </button>
);

const PatientSTLCard: React.FC<{
    stl: FileType;
    onTypeChange: (stlId: string, type: string) => void;
    onRemove: (stlId: string) => void;
    showTypeRequired?: boolean;
}> = ({ stl, onTypeChange, onRemove, showTypeRequired }) => {
    return (
        <div className="group flex flex-col gap-2.5 w-full p-2 rounded-lg transition-colors hover:bg-gray-50">
            <div className="aspect-[175/99] bg-gray-100 rounded-xl overflow-hidden relative flex items-center justify-center">
                <img src={stlIcon} alt={stl.name} className="w-1/2 h-1/2 object-contain" />
            </div>
            <div className="flex flex-col gap-1">
                <div className="flex flex-row gap-2 justify-between items-center p-1">
                    <label className="text-sm text-gray-800 font-normal leading-5 truncate flex-1">
                        {`${stl.name}`}
                    </label>
                    <RemoveButton onClick={() => onRemove(stl.id)} />
                </div>
                <STLTypeDropdown
                    stl={stl}
                    onTypeChange={onTypeChange}
                    showTypeRequired={showTypeRequired}
                />
                {showTypeRequired && (
                    <p className="text-xs text-red-600 font-medium">Select type</p>
                )}
            </div>
        </div>
    );
};

export default PatientSTLCard;
